import script from "./EntityList.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityList.vue?vue&type=script&setup=true&lang=js"

import "./EntityList.vue?vue&type=style&index=0&id=d164198c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d164198c"]])

export default __exports__